const o = 6048e5, c = 864e5, n = Symbol.for("constructDateFrom");
export {
  n as constructFromSymbol,
  c as millisecondsInDay,
  o as millisecondsInWeek
};
